import { render, staticRenderFns } from "./xeSimpleCardSetting.vue?vue&type=template&id=1c4e765e"
import script from "./xeSimpleCardSetting.vue?vue&type=script&lang=js"
export * from "./xeSimpleCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports